module.exports = __webpack_public_path__ + "img/locations_black_icon.95346347.svg";